export default __webpack_public_path__ + "/dist/images/marketplace_active.8fe3efc72b50fd1140536e18333b82b4.svg";